// Imports => Constants
import { ENDPOINTS } from '@constants';

export class PublicationsAPI {
  constructor(Instance) {
    this.Store = Instance.Store;
    this.Client = Instance.Client;
  }

  search(params) {
    return this.Client.get(ENDPOINTS.PUBLICATIONS.SEARCH, { params }).then(
      (response) => response.data
    );
  }

  attachments(id) {
    return this.Client.get(ENDPOINTS.PUBLICATIONS.ATTACHMENTS(id)).then(
      (response) => response.data
    );
  }

  single(id, params) {
    return this.Client.get(ENDPOINTS.PUBLICATIONS.SINGLE(id, params)).then(
      (response) => response.data
    );
  }

  themes(params) {
    return this.Client.get(ENDPOINTS.THEMES, { params }).then(
      (response) => response.data
    );
  }

  // Facets liften mee op de gewone lijstcall via _facetable/_facets-params;
  // de aparte aggregations-Accept-header bestaat niet meer in de nieuwe API.
  searchAggregations(params) {
    return this.Client.get(ENDPOINTS.PUBLICATIONS.SEARCH, { params }).then(
      (response) => response.data
    );
  }
}

export default PublicationsAPI;
